/* Specs validation portal — embeds MarlotAI customer validation inside Shopify */
(function () {
  function buildFrameUrl(root) {
    var params = new URLSearchParams(window.location.search);
    var quoteId = params.get("quote") || params.get("q") || params.get("quoteId");
    var token = params.get("t") || params.get("token");
    var aiBase = (root.getAttribute("data-ai-base") || "https://ai.marlotbaus.com/validate").replace(/\/$/, "");

    if (quoteId) return aiBase + "/quote/" + encodeURIComponent(quoteId);
    if (token) return aiBase + "/order/" + encodeURIComponent(token);
    return null;
  }

  function init() {
    var root = document.querySelector(".spec-validation-portal");
    if (!root) return;

    var loading = root.querySelector('[data-state="loading"]');
    var error = root.querySelector('[data-state="error"]');
    var iframe = root.querySelector(".spec-validation-portal__frame");
    var url = buildFrameUrl(root);

    function hideLoading() {
      if (!loading) return;
      loading.hidden = true;
      loading.setAttribute("aria-hidden", "true");
      loading.classList.add("spec-validation-portal__loading--hidden");
    }

    if (!url) {
      hideLoading();
      if (error) error.hidden = false;
      return;
    }

    function showFrame() {
      hideLoading();
      iframe.hidden = false;
    }

    iframe.addEventListener("load", showFrame);
    iframe.src = url;
    iframe.hidden = false;
    window.setTimeout(showFrame, 1200);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
